/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { clearDivWrapper } from "../../datatypeComponents/NarrativeEntry";
import XhtmlEntry from "../../datatypeComponents/JoditEditor";

const TextDivEntry = ({ elementName, startingValue, setResourceState, index, setKeyedResourceState }) => {

    const [textDivState, setTextDivState] = useState({});
    const [innerDivState, setInnerDivState] = useState({});
    const [startingDivValueState, setStartingDivValueState] = useState({});

    useEffect(() => {
        let startingTextDiv = {
            "div": "" // "div": '<div xmlns="http://www.w3.org/1999/xhtml"></div>'
        };
        if (startingValue) {
            if (typeof startingValue === "string") {
                startingTextDiv.div = startingValue;
            } else {
                alert(startingValue.toString());
            }
        }
        let startingDivTextValue = clearDivWrapper(startingTextDiv.div);
        let startingDivValue = { "divText": startingDivTextValue };
        setTextDivState(startingTextDiv);
        setInnerDivState(startingDivValue);
        setStartingDivValueState(startingDivValue);
    }, []);

    useEffect((() => {
        if (textDivState?.div) {
            if (setResourceState) {
                setResourceState(prevState => { return { ...prevState, [elementName]: textDivState.div }; });
            } else if (setKeyedResourceState) {
                setKeyedResourceState(prevState => {
                    let newObjectValue = prevState[index];
                    newObjectValue[elementName] = textDivState.div;
                    return {
                        ...prevState,
                        [index]: newObjectValue
                    }
                });
            }
        }
    }), [textDivState]);

    useEffect((() => {
        if ((typeof innerDivState.divText === "string") &&
            (startingDivValueState.divText !== innerDivState.divText &&
                ("<p>" + startingDivValueState.divText + "</p>") !== innerDivState.divText)
        ) {
            setTextDivState({
                "div": '<div xmlns="http://www.w3.org/1999/xhtml">' + innerDivState.divText + "</div>"
            });
        }
    }), [innerDivState]);

    return <div>
        <div style={{ marginLeft: "24px" }}>
            {(innerDivState.divText || innerDivState.divText === "") &&
                <XhtmlEntry elementName='divText'
                    startingValue={innerDivState.divText} setResourceState={setInnerDivState} />
            }
        </div>
    </div>
};

export default TextDivEntry;